/* eslint-disable react/style-prop-object */
import React, { useContext, useState } from "react";
import Searchbar from "../../Helpers/Searchbar/Searchbar";
import { filtrationcontext } from "../../../context/Filtercontext";
import trans from "../../../utils";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";
import { Segmented } from "antd";
import { EnvironmentOutlined, BarsOutlined } from "@ant-design/icons";
import { countries } from "../../../utils/CountryState/countries";
import { state } from "../../../utils/CountryState/states";
import { cities } from "../../../utils/CountryState/cities";

export default function POIsHead({
	setViewType,
	viewType,
	setFilter,
	setLatLng,
	setCurrentPage,
}) {
	const { setSearchQuery } = useContext(filtrationcontext);
	const [query, setQuery] = useState("");
	const handleSearch = (e) => {
		setQuery(e.target.value);
		setSearchQuery(e.target.value);
	};
	const [location, setLocation] = useState({
		country: null,
		state: null,
		city: null,
	});
	const [stateId, setStateId] = useState();
	console.log("Location", location);
	const typeOptions = [
		{ label: trans("supermarket"), value: "Supermarket" },
		{ label: trans("hospital"), value: "Hospital" },
		{ label: trans("checkpoint"), value: "Checkpoint" },
		{ label: trans("worksite"), value: "Worksite" },
		{ label: trans("department"), value: "Department" },
	];
	const tagOptions = [
		{ label: trans("Active"), value: "Active" },
		{ label: trans("Inactive"), value: "Inactive" },
	];
	const sanitizeForSQL = (str) => {
		// Allow only letters, numbers, spaces, and basic punctuation like hyphens
		return str.replace(/[^a-zA-Z0-9\s\-]/g, "");
	};
	return (
		<>
			<div className="bg-white p-16 d-flex align-items-baseline gap-3">
				<Searchbar
					style="search search-dark input-group"
					path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
					placeholder={trans("Search")}
					value={query}
					onChange={handleSearch}
				/>

				<InputSelect
					placeholder={trans("Type")}
					options={typeOptions}
					formstyle="flex-grow-1 text-capitalize"
					onChange={(e) => {
						setFilter((prev) => ({ ...prev, type: e }));
						setCurrentPage(1);
					}}
				/>
				<InputSelect
					allowClear
					placeholder={trans("Country")}
					onChange={(value) => {
						setCurrentPage(1);
						setLocation((prev) => ({ ...prev, country: value || null }));
						setFilter((prev) => {
							const updated = { ...prev };
							if (value) updated.country = value.toLowerCase();
							else delete updated.country;
							return updated;
						});
						setLatLng(() => {
							let country = countries?.find((i) => i.name === value);
							return {
								lat: Number(country?.latitude),
								lon: Number(country?.longitude),
								zoom: 6,
							};
						});
					}}
					options={countries?.map((i) => ({
						label: trans(i.name),
						value: i.name,
					}))}
					formstyle="flex-grow-1"
				/>

				<InputSelect
					allowClear
					value={location.state || undefined}
					placeholder={trans("State")}
					onChange={(value) => {
						const countryStates =
							state.find((s) => s.countryName === location.country)?.states ||
							[];

						const selected = countryStates.find((i) => i.name === value);

						if (selected) setStateId(selected.id);
						setCurrentPage(1);
						setLocation((prev) => ({ ...prev, state: value || null }));

						setFilter((prev) => {
							const updated = { ...prev };
							if (value) updated.state = value.toLowerCase();
							else delete updated.state;
							return updated;
						});
						setLatLng(() => {
							return {
								lat: Number(selected?.lat),
								lon: Number(selected?.lon),
								zoom: 10,
							};
						});
					}}
					options={
						state
							.find((i) => i.countryName === location.country)
							?.states?.map((i) => ({
								label: trans(i.name),
								value: sanitizeForSQL(i.name),
							})) || []
					}
					formstyle="flex-grow-1"
				/>

				<InputSelect
					allowClear
					placeholder={trans("City")}
					value={location.city || undefined}
					onChange={(value) => {
						setLocation((prev) => ({ ...prev, city: value || null }));
						setCurrentPage(1);
						setFilter((prev) => {
							const updated = { ...prev };
							if (value) updated.city = value.toLowerCase();
							else delete updated.city;
							return updated;
						});
						setLatLng(() => {
							const matchedState = cities
								?.flatMap((i) => i.states || [])
								.find((stateItem) => stateItem.id === stateId);

							const selectedCity = matchedState?.cities?.find(
								(city) => city?.name === value
							);

							return {
								lat: Number(selectedCity?.latitude),
								lon: Number(selectedCity?.longitude),
								zoom: 14,
							};
						});
					}}
					options={
						cities?.flatMap((i) => {
							const matchedState = i.states?.find(
								(stateItem) => stateItem.id === stateId
							);
							return (
								matchedState?.cities?.map((city) => ({
									label: trans(city.name),
									value: sanitizeForSQL(city.name),
								})) || []
							);
						}) || []
					}
					formstyle="flex-grow-1"
				/>

				{/* <InputSelect
					placeholder={trans("Tag")}
					options={tagOptions}
					formstyle="flex-grow-1"
					onChange={(value) =>
						setFilter((prev) => ({ ...prev, status: value }))
					}
				/> */}
				<Segmented
					style={{ width: "auto" }}
					options={[
						{ label: trans("List"), value: "List", icon: <BarsOutlined /> },
						{
							label: trans("Map"),
							value: "Map",
							icon: <EnvironmentOutlined />,
						},
					]}
					value={viewType}
					onChange={(e) => setViewType(e)}
				/>
			</div>
		</>
	);
}
